import { render } from "./delimiter.vue?vue&type=template&id=47ef9d08&scoped=true"
const script = {}

import "./delimiter.vue?vue&type=style&index=0&id=47ef9d08&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ef9d08"]])

export default __exports__